import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'serviceReportSum' })
export class ServiceReportSum implements PipeTransform {
  transform(jobno: any): any {
    let a: number = 0;
    if (!jobno) {
    } else {
      jobno.parts.forEach((x: any) => {
        a = Number(a) + Number(x.amount);
      });
    }
    return a;
  }
}
